import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};

export const EscalatorIcon = ({ width = 80, height = 80, fill = 'currentColor', ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M27.4997 27.1922L30.9222 23.2586L29.0996 21.6729L25.6526 25.6346L25.4991 23.5724L23.4341 23.726L23.8669 29.5414L29.8538 29.0921L29.6988 27.0272L27.4997 27.1922Z" fill={fill} />
            <path fillRule="evenodd" clipRule="evenodd" d="M54.0127 52.2063L50.4163 55.9818L52.1656 57.6481L55.7874 53.8458L55.8478 55.9126L57.9177 55.8521L57.7474 50.0231L51.7463 50.2022L51.8081 52.2721L54.0127 52.2063Z" fill={fill} />
            <path d="M45.5221 23.7441L23.434 46.5224H14.7705C14.2182 46.5224 13.7705 46.9701 13.7705 47.5224V59.3274C13.7705 59.8797 14.2182 60.3274 14.7705 60.3274H31.0268" stroke={fill} strokeWidth="2" />
            <path d="M35.1682 57.5664L56.566 35.4784H65.2295C65.7818 35.4784 66.2295 35.0307 66.2295 34.4784V22.6734C66.2295 22.1211 65.7818 21.6734 65.2295 21.6734H48.9732" stroke={fill} strokeWidth="2" />
        </svg>
    );
};
